export function isValidSendgridApiKey (value) {
  return /SG\.\w+\.[\w-]+/.test(value)
}
